import { RawFilters } from '@b2b/common/components/advanced-filters';
import { assign, setup } from 'xstate';
import { CustomersIndividualsListContext } from '../types';

type CustomersIndividualsListEvents =
  | { type: 'RESET' }
  | { type: 'TOGGLE_MODE' }
  | { type: 'FETCH_CUSTOMERS' }
  | { type: 'FETCH_CUSTOMERS_SUCCESS' }
  | { type: 'FETCH_CUSTOMERS_FAILED' }
  | { type: 'SET_BASIC_SEARCH_STATE'; searchQuery: string }
  | { type: 'SET_ADVANCED_SEARCH_STATE'; rawFilters: RawFilters };

export const customersIndividualsListMachine = setup({
  types: {
    context: {} as CustomersIndividualsListContext,
    events: {} as CustomersIndividualsListEvents,
  },

  actions: {
    reset: assign({
      searchMode: 'search',
      searchQuery: '',
      rawFilters: {},
    }),
    setBasicSearchState: assign(({ context }, searchQuery: string) => {
      return {
        ...context,
        searchMode: 'search' as const,
        searchQuery,
        rawFilters: {},
      };
    }),
    setAdvancedSearchState: assign(({ context }, rawFilters: RawFilters) => {
      return {
        ...context,
        searchMode: 'advancedSearch' as const,
        searchQuery: '',
        rawFilters,
      };
    }),
  },
}).createMachine({
  id: 'customersIndividualsList',

  context: () => {
    return {
      searchMode: 'search',
      searchQuery: '',
      rawFilters: {},
    };
  },

  initial: 'idle',

  on: {
    RESET: {
      target: '.idle',
      actions: { type: 'reset' },
    },

    SET_BASIC_SEARCH_STATE: {
      actions: {
        type: 'setBasicSearchState',
        params: ({ event }) => event.searchQuery,
      },
    },
    SET_ADVANCED_SEARCH_STATE: {
      actions: {
        type: 'setAdvancedSearchState',
        params: ({ event }) => event.rawFilters,
      },
    },
  },

  states: {
    idle: {
      initial: 'default',
      on: {
        FETCH_CUSTOMERS: { target: '#loading' },
      },

      states: {
        default: {
          on: {
            TOGGLE_MODE: { target: 'selecting_duplicates' },
          },
        },

        selecting_duplicates: {
          on: {
            TOGGLE_MODE: { target: 'default' },
          },
        },

        hist: { type: 'history' },
      },
    },

    loading: {
      id: 'loading',
      tags: ['loading'],

      on: {
        FETCH_CUSTOMERS_SUCCESS: { target: 'idle.hist' },
        FETCH_CUSTOMERS_FAILED: { target: 'error' },
      },
    },

    error: {
      on: {
        FETCH_CUSTOMERS: { target: '#loading' },
      },
    },
  },
});
